/** Used to iterate `mapping.aryMethodMap` keys. */
exports.caps = ['1', '2', '3', '4'];
